import * as React from 'react';
//import { default as Transition } from 'react-transition-group/Transition'; // TODO: when the definition file is fixed
const Transition = require('react-transition-group/Transition').default;

export type Props = {
    id?: string;
    visible: boolean;
    duration: number | { enter?: number; exit?: number };
    children: ((visible: boolean) => void) | any; // tslint:disable-line
    style?: object;
    from?: string | number;
    to?: string | number;
    className?: string;
    unmountOnExit?: boolean;
};

type TransitionState = 'entering' | 'entered' | 'exiting' | 'exited';

const getStyle = (state: TransitionState, from: string | number, to: string | number) => {
    const isIn = state === 'entering' || state === 'entered';
    const scale = (isIn ? to : from) || '0';
    return {
        opacity: isIn ? 1 : 0,
        transform: `scale(${scale})`,
    };
};

export const FadeScale = ({ id, visible, duration, children, from = 0, to = 1, className, unmountOnExit, style }: Props) => {
    const durationIn = typeof duration === 'number' ? duration : duration.enter;
    const durationOut = typeof duration === 'number' ? duration : duration.exit;
    return (
        <Transition in={ visible } timeout={ duration }>
            { (state: TransitionState) =>
                <div
                    id={ id }
                    className={ className }
                    style={ {
                        transition: `all ${state === 'entering' || state === 'entered' ? durationIn : durationOut}ms ease-out`,
                        ...style,
                        ...getStyle(state, from, to),
                    } }
                >
                    {
                        typeof children === 'function'
                            ? children(state !== 'exited')
                            : state !== 'exited' || !unmountOnExit
                                ? children
                                : null
                    }
                </div>
            }
        </Transition>
    );
};



// WEBPACK FOOTER //
// ./src/ui/transitions/FadeScale.tsx